<template>
  <div class="GeolocationPopup__Wrapper" v-if="showPopUp">
    <div class="GeolocationPopup" :class="settings.store_selector_bg ? 'popupImage' : ''" data-section-type="geolocation-popup" aria-hidden="false">
      <div v-if="settings.store_selector_bg" class="GeolocationPopup__Left hidden-pocket" v-bind:style="{ backgroundImage: 'url(' + settings.store_selector_bg_url + ')'}">
        <h4 class="Heading u-h4">
          <span v-for="text in translations.geolocation.title.split('#')" :key="text">{{text}}</span>
        </h4>
      </div>
      
      <div class="GeolocationPopup__Right GeolocationPopup__Right-Change" v-if="showMarketSelectors">
        <h5 class="GeolocationPopup__Heading Heading u-h5">{{translations.geolocation.change_country_location}}</h5>

        <form id="localization_form_geolocation" class="GeolocationPopup__LocalizationForm">
          <div class="Form__Select">
            <img class="Country__flag flag" :src="country_flag"/>
            <select name="select" title="Select" class="Select_country" @change="getLanguages();" v-model="selected_country">
                <option v-for="country in localization.available_countries" :key="country" :value="country.iso_code">
                  {{ country.name }} ({{ country.currency.symbol }}  {{ country.currency.iso_code }})
                </option>
            </select>
          </div>

          <div class="Form__Select" :class="available_languages.length > 1 ? '' : 'hidden'">
            <img class="Language__flag flag" :src="language_flag"/>
            <select name="select" title="Select" class="Select_lang" @change="languageChanged()" v-model="selected_language">
                <option v-for="language in available_languages" :key="language" :value="language.iso_code">
                  {{ language.endonym_name }}
                </option>
            </select>
          </div>

          <button type="button" class="Button Button--primary GeolocationPopup__Save" :disabled="isLoading" @click="submit(true)">
            <span v-if="!isLoading">{{translations.geolocation.save_preferences}}</span>
            <span v-if="isLoading" v-html="icons.loader.outerHTML"></span>
          </button>

          <div class="GeolocationPopup__Cancel"><span @click="closeModal();">{{translations.geolocation.cancel}}</span></div>
        </form>
      </div>
      
      <div class="GeolocationPopup__Right GeolocationPopup__Right-Confirm" v-if="!showMarketSelectors">
        
        <img class="GeolocationPopup__Flag" :src="localization.country_flag"/>

        <h5 class="GeolocationPopup__Heading Heading u-h5">{{ translations.geolocation.we_ship_in }}</h5>

        <p class="GeolocationPopup__Description" v-if="translations.geolocation.description != ''">{{translations.geolocation.description}}</p>

        <ul class="GeolocationPopup__Advantages">
          <li v-for="bullet in translations.geolocation.bullets" :key="bullet">{{bullet}}</li>
        </ul>

        <button type="button" class="Button Button--primary GeolocationPopup__Save" @click="submit()">{{ translations.geolocation.continue_in }}</button>

        <div class="GeolocationPopup__Change" @click="showMarketSelectors = true">{{ translations.geolocation.change_country_location }}</div>
      </div>
    </div>
    <div class="GeolocationPopup__Overlay"></div>
  </div>
</template>

<script>

export default {
  props: {
    settings: {},
    localization: {},
    translations: {}
  },
  data: function () {
    return {
      isLoading: false,
      country_flag: '',
      language_flag: '',
      available_languages: [],
      current_market: false,
      current_language: false,
      current_country: false,
      selected_market: false,
      selected_country: this.localization.country_iso_code,
      selected_language: this.localization.language_iso_code,
      redirect_url: false,
      showMarketSelectors: false,
      showPopUp: false,
      icons: window.geolocation_popup.icons
    }
  },
  name: 'GeolocationPopup',
  computed: {},  
  mounted() {
    this.current_language = this.getCookie('language');
    this.current_country = this.getCookie('country');
    this.current_market = this.getCookie('market');
    let open_popup = this.getCookie('open_popup');
    
    if(open_popup == 'true' || !open_popup){
      if (!this.current_language || !this.current_country) {
        this.init();
      }else if(this.current_country != this.localization.country_iso_code || this.current_language != this.localization.language_iso_code){
        this.redirectToMarket(this.current_language, this.current_country, true);
      }
    }else{
      this.deleteCookie('open_popup');
      if(!this.current_language)this.current_language = this.setCookie('language', this.localization.language_iso_code);
    }
  },
  methods: {
    init() {
      this.country_flag = this.localization.country_flag;
      this.language_flag = this.localization.language_flag;
      this.available_languages = this.localization.available_languages;

      fetch('/browsing_context_suggestions.json').then((response) => response.json())
        .then((res) => {
          if((!this.current_language || !this.current_country) && res.detected_values.country.handle.toLowerCase() !== window.localization.iso_code.toLowerCase()){
            this.showPopUp = true;
            this.showMarketSelectors = true;
            this.selected_country = res.detected_values.country.handle;
            this.getLanguages(true);
          }else if(res.detected_values.country.handle.toLowerCase() == window.localization.iso_code.toLowerCase()){
            this.showPopUp = true;
          }
        });
    },
    getLanguages(change_translations_language = false) {
      this.isLoading = true;
      this.country_flag = this.country_flag.substr(0, this.country_flag.indexOf('.svg') - 2) + this.selected_country + this.country_flag.substr(this.country_flag.indexOf('.svg'));
      this.available_languages = [];

      let formData = new FormData();
      formData.append('country_code', this.selected_country);
      formData.append('form_type', 'localization')
      formData.append('_method', 'put')
      formData.append('return_to', '/')

      fetch(location.origin + '/localization', {
        body: formData,
        method: 'POST',
      })
      .then(response => {
        this.redirect_url = response.url;
        this.selected_market = response.url.replace(location.origin,'');
        return response.text()
      })
      .then(data => {
        let responseDocument = document.createElement('html');
        responseDocument.innerHTML = data;

        let languagesWrapper = responseDocument.querySelector('#footer-locale-popover');
        if (languagesWrapper) {
          let languages = languagesWrapper.querySelectorAll('[name="locale_code"]');
          this.available_languages = Array.from(languages).map(item => {return {endonym_name: item.innerText, iso_code: item.value}});
          this.selected_language = Array.from(languages).filter(lang => {if(lang.classList.contains('is-selected'))return lang})[0].value;
          this.changeLanguageFlag();
        }else{
          let language = JSON.parse(responseDocument.querySelector('#geolocation-popup').getAttribute(':localization')).language_iso_code,
            item = [];
          item['endonym_name'] = language;
          item['iso_code'] = language;
          this.available_languages[0] = item;
          this.selected_language = language;
        }
        
        if(change_translations_language){
          let translated_texts = JSON.parse(responseDocument.querySelector('#geolocation-popup').getAttribute(':translations'));
          this.changeTranslationLanguage(translated_texts);
        }

        this.isLoading = false;
      });
    },
    changeTranslationLanguage(translations){
      this.translations = translations;
    },
    languageChanged() {
      this.redirect_url = false;
      this.selected_market = false;
      this.changeLanguageFlag();
    },
    changeLanguageFlag(){
      this.language_flag =  this.language_flag.substr(0, this.language_flag.indexOf('.svg') - 2) + this.selected_language.toUpperCase() + this.language_flag.substr(this.language_flag.indexOf('.svg'));
    },
    closeModal() {
      this.showPopUp = false;
    },
    submit(redirect = false) {
      this.saveCookies();
      if (redirect) this.redirectToMarket(this.selected_language, this.selected_country);
      this.closeModal();
    },
    saveCookies(){
      this.setCookie('country', this.selected_country);
      this.setCookie('language', this.selected_language);
      if(this.selected_market)this.setCookie('market', this.selected_market);
    },
    redirectToMarket(lang, country, autoredirect = false) {
      let return_url = this.getReturnUrl();

      if(!autoredirect || (autoredirect && !this.getCookie('redirected'))){
        if(this.redirect_url){
          if(this.redirect_url.slice(-1) != '/' && return_url != '/'){
            this.redirect_url = this.redirect_url + '/';
          }
          window.location.href = this.redirect_url + return_url;
        }else if(this.current_market && this.current_country && this.current_language){
          window.location.href = location.origin + this.current_market + return_url;
        }else{
          /* If user has not select a market and the user hasn't chosen one previously ot the market cookie has been removed,
          we ask Shopify which is the right link to redirect to */
          this.isLoading = true;
          
          let formData = new FormData();
          formData.append('country_code', country);
          formData.append('locale_code', lang);
          formData.append('form_type', 'localization');
          formData.append('_method', 'put');
          formData.append('return_to', return_url);

          fetch(location.origin + '/localization', {
            body: formData,
            method: 'POST',
          }).then(response => {
            let market;
            if(response.url.replace(location.origin,'').replace(return_url,'') == '/'){
              market = response.url.replace(location.origin,'').replace(return_url,'');
            }else{
              market = response.url.replace(location.origin,'/').replace(return_url,'');
            }
            if(!this.selected_market)this.setCookie('market', market);
            window.location.href = response.url;
          })
        }

        if(autoredirect){
          let expires = new Date();
          expires.setTime(expires.getTime() + (1*60*1000));
          this.setCookie('redirected', true, expires.toGMTString());
        }
      }else{
        this.deleteCookie('market');
        this.deleteCookie('country');
        this.deleteCookie('language');
        this.deleteCookie('redirected');
        this.init();
      }
    },
    getReturnUrl(){
      let param = '',
        return_url = '';
      if(location.href.indexOf('?') != -1) param = location.href.slice(location.href.indexOf('?'));
      //Remove previous market
      if(location.pathname.search(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3}\/)/g) != -1){
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3}\/)/g,'') + param;
      }else if(location.pathname.search(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3})$/g) != -1){
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3})$/g,'') + param;
      }else if(location.pathname.search(/(\/[A-Za-z]{2,3}\/)/g) != -1){
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}\/)/g,'') + param;
      }else if(location.pathname.search(/(\/[A-Za-z]{2,3})$/g) != -1){
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3})$/g,'') + param;
      }else{
        return_url = location.pathname + param;
      }

      return return_url;
    },
    getCookie(cName) {
      const name = cName + '=';
      const cDecoded = decodeURIComponent(document.cookie);
      const cArr = cDecoded.split('; ');
      let res;
      cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
      });
      return res;
    },
    setCookie(cName, cValue, expires = false) {
      if(!expires){
        let now = new Date();
        let time = now.getTime();
        let expireTime = time + 1000*31536000;
        now.setTime(expireTime);
        expires = now.toUTCString();
      }
      
      let current_cookie = this.getCookie(cName);
      if ((current_cookie && current_cookie != cValue) || !current_cookie){
        if(expires){
          document.cookie = cName + '=' + cValue + ';expires=' + expires + ';path=/;';
        }else{
          document.cookie = cName + '=' + cValue + ';path=/;';
        }
      }
    },
    deleteCookie(cookie) {
      document.cookie = cookie + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }
};
</script>
